import { roles } from './permissions';

/**
 * Route permissions.
 */
const routes = new Map();
routes.set('companies', [roles.ALL]);
routes.set('pages', [roles.OWNER, roles.ADMIN, roles.MANAGER]);
routes.set('pages/create', [roles.OWNER, roles.ADMIN, roles.MANAGER]);
routes.set('pages/**', [roles.OWNER, roles.ADMIN, roles.MANAGER]);
routes.set('apps', [roles.INSIDER, roles.OWNER, roles.ADMIN]);
routes.set('clients', [roles.OWNER, roles.ADMIN, roles.MANAGER]);
routes.set('clients/**', [roles.OWNER, roles.ADMIN, roles.MANAGER]);
routes.set('settings', [roles.OWNER, roles.ADMIN]);

const hasRoutePermission = (route, role) => {
    const path = route.split('/').filter((path) => path.length > 0);

    if (path.length === 0) return true;

    let targetRoute = path[0];

    if (path.length > 1) {
        for (let i = 1; i < path.length; i++) {
            if (routes.has(targetRoute + '/' + path[i])) {
                targetRoute += '/' + path[i];
            } else {
                targetRoute += '/**';
            }
        }
    }

    const routePermissions = routes.get(targetRoute);

    if (!Array.isArray(routePermissions)) return false;

    return (
        routePermissions.includes(role) || routePermissions.includes(roles.ALL)
    );
};

export { hasRoutePermission };
